import React, { useState } from "react";
import { Subaccount } from "@design-system/Subaccount/Subaccount";
import { VStack } from "@design-system/VStack/VStack";
import { TextControl, VariantGrid, VariantItem } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./IdentityIconsPlayground.module.scss";

export const SubaccountPlayground = () => {
    const [name, setName] = useState("Operating checking");
    const [accountNumber, setAccountNumber] = useState("9876543210");

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Subaccount</h2>
                    <VStack gap={12}>
                        <TextControl
                            label="Name"
                            value={name}
                            onChange={setName}
                        />
                        <TextControl
                            label="Account number"
                            value={accountNumber}
                            onChange={setAccountNumber}
                        />
                    </VStack>
                </section>
            }
        >
            <ShowcasePreview
                summary="display name formatting"
                output={JSON.stringify(
                    {
                        subaccount: {
                            name,
                            accountNumber: accountNumber || null,
                        },
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.content}>
                    <div className={styles.centered}>
                        <Subaccount
                            subaccount={{
                                name,
                                accountNumber: accountNumber || null,
                            }}
                        />
                    </div>
                    <VariantGrid title="Label rendering" columns="auto">
                        <VariantItem label="account suffix appended">
                            <Subaccount
                                subaccount={{
                                    name: "Savings",
                                    accountNumber: "1234567890",
                                }}
                            />
                        </VariantItem>
                        <VariantItem label="suffix already present">
                            <Subaccount
                                subaccount={{
                                    name: "Payroll ••42",
                                    accountNumber: "1234567842",
                                }}
                            />
                        </VariantItem>
                        <VariantItem label="no account number">
                            <Subaccount
                                subaccount={{
                                    name: "Cash on hand",
                                    accountNumber: null,
                                }}
                            />
                        </VariantItem>
                    </VariantGrid>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
